import {
  Text,
  View,
  IconButton,
  IconExitFullScreenLine,
  IconSettingsLine,
  Flex,
  IconExternalLinkLine,
  IconNoLine,
} from '@smarterservices/smarter-ui';
import useAppStore from '../../stores/app';
import useSessionStore from '../../stores/session';
import { useState, useEffect } from 'react';
import Card from '../Common/Card';
import { Menu } from '@instructure/ui';
import { SessionViewer } from '@shared/components/proctoring/SessionViewer';
//import ReactSession from './ReactSession';
import ConfirmReviewExitModal from '../Modal/ConfirmReviewExit';

const apiUrl = import.meta.env.VITE_API_URL;
const identity =
  import.meta.env.VITE_IDENTITY || localStorage.getItem('identity');
const websocketUrl = import.meta.env.VITE_WEBSOCKET_URL;

const Focus = () => {
  const { drawerWidth, closeDrawer, setDrawerCloseConfirmation } =
    useAppStore();
  const {
    focusedSessionSid,
    focusedSession,
    clearFocusedSession,
    setTransferSessionSid,
    setEndSessionSid,
    transitionSession,
    getSessionMediaConnectionBundle,
  } = useSessionStore();
  const [, setSessionLoaded] = useState(false);
  const [showExitConfirmation, setShowExitConfirmation] = useState(false);

  const handleConfirmedExit = () => {
    if (focusedSession.location === 'review') {
      setShowExitConfirmation(false);
      transitionSession(focusedSessionSid, 'waiting');
    }

    clearFocusedSession();
    setDrawerCloseConfirmation(null);
    closeDrawer();
  };

  const handleExit = () => {
    if (focusedSession.location === 'review') {
      setShowExitConfirmation(true);
    } else {
      handleConfirmedExit();
    }
  };

  const handleSessionApproved = () => {
    transitionSession(focusedSessionSid, 'testing');
  };

  useEffect(() => {
    if (focusedSession) {
      console.log(focusedSessionSid);
      console.log(getSessionMediaConnectionBundle(focusedSessionSid));

      setSessionLoaded(true);

      setDrawerCloseConfirmation(handleExit);
    }
  }, [focusedSession]);

  return (
    <>
      <View
        as="div"
        id="FocusModeContainer"
        width="100%"
        height="100%"
        textAlign="center"
        margin="none"
        padding="x-small"
        overflowX="hidden"
        overflowY="hidden"
        withVisualDebug={false}
      >
        <Card>
          <Card.Header>
            <Card.Title>
              <Text weight="bold">
                {focusedSession?.firstName} {focusedSession?.lastName}
              </Text>
            </Card.Title>

            {/* Only show the actions if you are not currently reviewing the session... */}
            <Card.Actions>
              <Menu
                placement="bottom end"
                shouldContainFocus
                shouldReturnFocus
                mountNode={() => document.body} // Ensures the menu overlays everything
                trigger={
                  <IconButton
                    withBackground={false}
                    withBorder={false}
                    color="primary"
                    size="small"
                    screenReaderLabel="Session Options"
                    margin="none"
                    padding="none"
                  >
                    <IconSettingsLine />
                  </IconButton>
                }
              >
                <Menu.Item
                  onSelect={() => setTransferSessionSid(focusedSessionSid)}
                >
                  <Flex alignItems="center">
                    <Flex.Item margin="0 xx-small 0 0">
                      <IconExternalLinkLine size="x-small" />
                    </Flex.Item>
                    <Flex.Item>
                      <Text>Transfer</Text>
                    </Flex.Item>
                  </Flex>
                </Menu.Item>
                <Menu.Separator />
                <Menu.Item onSelect={() => setEndSessionSid(focusedSessionSid)}>
                  <Flex alignItems="center">
                    <Flex.Item margin="0 xx-small 0 0">
                      <IconNoLine size="x-small" />
                    </Flex.Item>
                    <Text>End Session</Text>
                  </Flex>
                </Menu.Item>
              </Menu>
              <IconButton
                withBackground={false}
                withBorder={false}
                color="primary"
                size="small"
                screenReaderLabel="Expand To Focus Mode"
                margin="none none none xx-small"
                padding="none"
                onClick={closeDrawer}
              >
                <IconExitFullScreenLine />
              </IconButton>
            </Card.Actions>
          </Card.Header>
          <Card.Body>
            <SessionViewer
              connectionBundle={getSessionMediaConnectionBundle(focusedSessionSid)}
              sessionSid={focusedSessionSid}
              installSid={focusedSession?.installSid}
              examSid={focusedSession?.examSid}
              apiUrl={apiUrl}
              roomId={focusedSessionSid}
              //spToken={useAppStore.getState().user.token}
              spToken="eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6IjMyMzY1NTAwLTcwNTQtMTFlZi1iZDdhLTViODA3NmQyNjIwMyIsImNyZWF0ZV90aW1lIjoxNzI2MDY5MjM5Mzc2LCJ0aW1lb3V0IjowfQ.heak3mv9ot-n2QYArb8R2WOKQdmWrTLu-CSxs4X-1cU"
              identity={`${useAppStore.getState().user.identity}_focus`}
              websocketUrl={websocketUrl}
              onSessionApproved={handleSessionApproved}
              type="proctor"
              enabledComponents={{
                sessionDetails: true,
                microphone: true,
                chat: true,
              }}
              video={{
                sources: ['live', 'recorded'],
                default: 'live',
              }}
            />
          </Card.Body>
        </Card>
      </View>
      <ConfirmReviewExitModal
        show={showExitConfirmation}
        onCancel={() => setShowExitConfirmation(false)}
        onConfirmation={() => handleConfirmedExit()}
      />
    </>
  );
};

export default Focus;
